<div class="relative group cursor-pointer w-40 h-40 mx-auto">
  <!-- Foto -->
  <img
    id="profilePic"
    src="https://via.placeholder.com/150"
    alt="Perfil"
    class="w-full h-full object-cover rounded-full border-4 border-gray-300"
  />

  <!-- Input oculto -->
  <input type="file" id="fileInput" class="hidden" />

  <!-- Círculo borde (solo visible en hover) -->
  <div
    class="absolute inset-0 rounded-full border-2 border-gray-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
  ></div>

  <!-- Icono central -->
  <label
    for="fileInput"
    class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
  >
    <svg width="30" height="30" viewBox="0 0 24 24" class="text-white">
      <path
        fill="currentColor"
        d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h16v12zM12 9c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
      />
    </svg>
  </label>
</div>
